import { ConfirmationDialog } from 'components/ConfirmationDialog';
import { ErrorHandlingModal } from 'components/ErrorHandlingModal';
import { RequestStatus } from 'features/request/requestSlice';
import { WorkOrderStatusEnum } from 'gql/graphql';

import React, { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';

import { useWorkOrderOtherDelete } from '../WorkOrderOtherDelete/useWorkOrderOtherDelete';

export const WorkOrderOtherDeleteItem = ({ workOrderStatus }: { workOrderStatus?: WorkOrderStatusEnum }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { otherId } = useParams();

    const isActOther = workOrderStatus === WorkOrderStatusEnum.InProgress;

    const {
        isSubmitted,
        deleteData,
        deleteStatus,
        deleteError,
        deleteActionCreator,
        resetRemovedData,
        handleCloseModalError,
        handleCreateReport,
    } = useWorkOrderOtherDelete({
        isActOther,
    });

    const handleDeleteExactly = useCallback(() => {
        const variables = { workOrderOtherPriceIds: [Number(otherId)] };

        dispatch(deleteActionCreator(variables));
    }, [deleteActionCreator, dispatch, otherId]);

    const handlerCloseModal = useCallback(
        (wasSubmit) => {
            if (!wasSubmit) {
                navigate('../', { replace: true });
            }
        },
        [navigate],
    );

    useEffect(() => {
        if (deleteStatus === RequestStatus.SUCCESS) {
            navigate('../', { replace: true, state: { reload: otherId } });
            resetRemovedData(null);
        }
    }, [navigate, deleteStatus, otherId, resetRemovedData]);

    const handleCloseModalErrorAndNavigate = useCallback(() => {
        handleCloseModalError();
        handlerCloseModal(false);
    }, [handleCloseModalError, handlerCloseModal]);

    return (
        <>
            <ConfirmationDialog
                textHeader="УДАЛЕНИЕ ЗАПИСЕЙ"
                textConfirmation="Вы уверены, что хотите удалить записи?"
                isOpened
                onSubmit={handleDeleteExactly}
                onClose={handlerCloseModal}
                cancelButtonText="Не удалять"
                confirmButtonText="Удалить"
            />
            <ErrorHandlingModal
                titleText="Удаление записи"
                isSubmitted={isSubmitted}
                statusRequest={deleteStatus}
                dataRequest={deleteData}
                errorsRequest={deleteError}
                handleCloseModalError={handleCloseModalErrorAndNavigate}
                handleCreateReport={handleCreateReport}
            />
        </>
    );
};

WorkOrderOtherDeleteItem.displayName = 'WorkOrderOtherDeleteItem';
